import { useState, useEffect } from "react";
import GooglePlacesAutocomplete, {
  geocodeByPlaceId,
} from "react-google-places-autocomplete";

import { FormGroup, Label } from "reactstrap";
import { Colxx } from "../../components/common/CustomBootstrap";
import { ENV } from "../../config/ENV";

const GooglePlacesComponent = (props) => {
  const [address, setAddress] = useState();
  const [addressObj, setAddressObj] = useState();
  const getAddressObject = (address_components, geoLocation) => {
    let address = {
      streetnumber:"",
      street: "",
      area: "",
      city: "",
      state: "",
      zipcode: "",
      country: "",
      latitude: "",
      longitude: "",
    };

    address_components.forEach(function (c) {

      switch (c.types[0]) {
        case "street_number":
          address.streetnumber = c.long_name;
          break;
        case "route":
          address.street = address.streetnumber + " " + c.long_name;
          break;
        case "locality":
          address.city = c.long_name;
          break;
        case "neighborhood":
          address.area = c.long_name;
          break;
        case "administrative_area_level_1":
          address.state = c.short_name;
          break;
        case "postal_code":
          address.zipcode = c.long_name;
          break;
        case "country":
          address.country = c.long_name;
          break;
        default:
          break;
      }
      
    });
    
    address.latitude = geoLocation.lat();
    address.longitude = geoLocation.lng();
    props.parentCallback(address);
    return address;
  };

  useEffect(() => {
    const func = async () => {
      const geocodeObj =
        address &&
        address.value &&
        (await geocodeByPlaceId(address.value.place_id));
      const addressObject =
        geocodeObj &&
        getAddressObject(
          geocodeObj[0].address_components,
          geocodeObj[0].geometry.location
        );
      setAddressObj(addressObject);
    };
    func();
  }, [address]);

  return (
    <FormGroup row>
      <Colxx sm={12}>
        <Label>Search Location</Label>
        <GooglePlacesAutocomplete
          apiKey={ENV.google_api_key}
          selectProps={{
            isClearable: true,
            value: address,
            placeholder: "Type address to auto populate",
            onChange: (val) => {
             setAddress(val);
            },

            styles: {
              input: (provided) => ({
                ...provided,
                boxShadow: 0,
                "&:hover": {
                  border: "1px solid purple",
                },
              }),
              singleValue: (provided) => ({
                ...provided,
                boxShadow: 0,
                "&:hover": {
                  border: "1px solid purple",
                },
              }),
            },
          }}
          autocompletionRequest={{
            fields: ["address_components", "geometry"],
            strictBounds: false,
            types: ['establishment','geocode'],
          }}
        />
      </Colxx>
    </FormGroup>
  );
};

export default GooglePlacesComponent;
